module.exports = __webpack_public_path__ + "assets/img/greenestImg5.1507b3a2.png";